export default {"src":"/_next/static/media/arrow.b028097c.svg","height":19,"width":99,"blurWidth":0,"blurHeight":0};